export default __webpack_public_path__ + "static/media/image-5.77262711.png";